import { LitElement, html, css, styleMap, utils } from '@hh/global.js'
class HHSparkleBackground extends LitElement {
  static properties = {
  }

  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()
    window.addEventListener('resize', this.generateContent.bind(this))
    setTimeout(() => {
      this.generateContent()
    }, 0)
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    window.removeEventListener('resize', this.generateContent.bind(this))
  }

  generateContent() {
    const content = this.shadowRoot.querySelector('.js-content')
    if (!content) return false

    const { height, width } = this.getBoundingClientRect()
    const horizontalCount = width / 40
    const verticalCount = height / 40
    const totalCount = (horizontalCount + 1) * (verticalCount + 1)
    let template = ''

    for (var i = 0; i < totalCount; i++) {
      template += '<div class="box"></div>'
    }

    content.innerHTML = ''
    content.insertAdjacentHTML('beforeend', template)
  }

  render() {
    return html`<div
        class="sparkle-background"
      >
        <div class="sparkle-background-inner js-content"></div>
      </div>`
  }

  static styles = css`
    .sparkle-background {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      line-height: 100%;
      overflow: hidden;
    }

    .sparkle-background-inner .box {
      position: relative;
      float: left;
      width: 4rem;
      height: 4rem;
    }

    .sparkle-background-inner .box::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      border-radius: 50%;
      opacity: 0;
      background-image: var(--hh-sparkle-image);
      background-size: cover;
      transition: opacity 0.3s cubic-bezier(1, 0.65, 1, 1) 0s;
    }

    .box:hover::before {
      opacity: 1;
      transition: 0s opacity ease-in;
    }
  `
}

customElements.define('hh-sparkle-background', HHSparkleBackground)
